import {createContext} from 'react';
//react 2 - shanon Fritz
export const RecipesContext = createContext();